







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BIconClock } from 'bootstrap-vue';
import RateDisplay from '@/components/RateDisplay.vue';
import DateTime from '@/components/DateTime.vue';
import api from '@/api/apiclient';
import { IComment } from '@/api/interface';


@Component({
  components: {DateTime, RateDisplay, BIconClock}
})
export default class CommentsList extends Vue {

  @Prop({ default: 0 })
  private routeId!: number;

  private action = '/cms/api/comments/' + this.routeId;

  private list: IComment[] = [];
  private loading = false;

  mounted() {
    this.loadComments();
  }

  loadComments() {
    this.loading = true;
    api.get<IComment[]>(this.action)
        .then(list => {
          if (list) this.list = list;
          else this.list = [];
          Vue.nextTick(this.processHash);
        })
        .catch(e => console.log(e.message || e))
        .finally(() => this.loading = false)
  }

  processHash() {
    const hash = window.location.hash;
    const result = hash.match(/^#comment-([0-9]+)$/);
    if (!result) return false;
    const id = parseInt(result[1]);
    const found = this.list.some(cmm => id && cmm?.comment_id == id);
    if (found) {
      this.scrollToComment(id);
      return true;
    }
    else return false;
  }

  scrollToComment(id: number) {
    const hash = '#comment-' + id;
    const div = document.querySelector(hash);
    if (div) div.scrollIntoView(false);
  }

  public addComment(comment: IComment) {
    this.list.push(comment);
    Vue.nextTick(() => {
      this.scrollToComment(comment.comment_id);
    });
  }
}
